import React, { useEffect, useRef, useState } from "react";
import PubNub from "pubnub";
import axios from "axios";
import "./ChatWidget.css";

const PUB_KEY = "pub-c-3d3bd6fe-f1bc-45c7-ada4-449d33a828e2";
const SUB_KEY = "sub-c-cb5d5b4e-3b82-444c-9fd1-30bb2c475039";
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export default function ChatWidget({ user = {}, bookingId, onClose, sp,fromChatlist }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const messagesEndRef = useRef(null);
  const pnRef = useRef(null);

  const userId = String(user?.user_id ?? user?.id ?? `guest_${Math.floor(Math.random() * 10000)}`);
  const userName = String(user?.full_name ?? user?.name ?? "Guest");
  // const channelId = `CH_Eagle_USR_${user.user_id}_STF_${!fromChatlist ? sp.service_provider.sp_id:sp.sp_id}`;
  const channelId = useRef(
    `CH_Eagle_USR_${user.user_id}_STF_${!fromChatlist ? sp.service_provider.sp_id : sp.sp_id}`
  ).current;
  
  console.log("sp",sp,"fromChatlist",fromChatlist)

  const safeTrim = (v) => String(v ?? "").trim();

  function normalizeMessage(raw) {
    try {
      let m = raw;
      if (m && typeof m === "object" && "entry" in m) m = m.entry;
      if (typeof m !== "object" && typeof m !== "string") m = String(m ?? "");
      if (typeof m === "string") m = { text: m };

      const textCandidate = m.text ?? m.message ?? m.payload ?? m.content ?? (m._raw?.content ?? "");

      return {
        id: m.id || m.messageId || m.timetoken || `${m.senderId ?? userId}_${m.ts ?? Date.now()}_${Math.floor(Math.random() * 100000)}`,
        channelId: m.channelId || channelId,
        senderId: String(m.senderId ?? m.from ?? userId),
        senderName: String(m.senderName ?? m.name ?? userName),
        image: m.image ?? null,
        text: safeTrim(textCandidate),
        ts: m.ts || (m.timetoken ? Number(String(m.timetoken).slice(0, -6)) : Date.now()),
        _raw: m,
      };
    } catch {
      return {
        id: `bad_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
        channelId,
        senderId: userId,
        senderName: userName,
        text: safeTrim(raw),
        ts: Date.now(),
        _raw: raw,
      };
    }
  }

  function pushMessage(raw) {
    const norm = normalizeMessage(raw);
    setMessages((prev) => {
      if (prev.find((p) => p.id === norm.id)) return prev;
      return [...prev, norm].slice(-500);
    });
  }

  useEffect(() => {
    const pn = new PubNub({
      publishKey: PUB_KEY,
      subscribeKey: SUB_KEY,
      uuid: "Customer-" + userId,
    });
    pnRef.current = pn;

    if (API_BASE) {
      axios.post(`${API_BASE}/createChannel`, { channelId, bookingId }).catch(() => { });
    }

    const listener = {
      message: (event) => {
        const eventChannel = event.channel || event.subscription || event.channelName;
        if (eventChannel && eventChannel !== channelId) return;

        const raw = event.message ?? event;
        pushMessage(raw);
      },
    };

    pn.addListener(listener);
    pn.subscribe({ channels: [channelId] });

    pn.history({ channel: channelId, count: 50 })
      .then((res) => {
        console.log("history",res.messages)
        const incoming = Array.isArray(res.messages) ? res.messages : [];
        const normalized = incoming.map(normalizeMessage);
        setMessages(normalized);
      })
      .catch(() => { });

    return () => {
      try {
        pn.unsubscribe({ channels: [channelId] });
        pn.removeListener(listener);
      } catch { }
      pnRef.current = null;
    };
  }, [channelId, userId]);

  useEffect(() => {
    if (messagesEndRef.current) {
      try {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      } catch { }
    }
  }, [messages]);

  const sendMessage = () => {
    const text = safeTrim(input);
    if (!text) return;

    const msg = {
      id: `${userId}_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
      channelId,
      senderId: userId,
      senderName: "Customer",
      content: text,
      image: null,
      ts: Date.now(),
    };

    pushMessage(msg);
    setInput("");

    const pn = pnRef.current;
    if (!pn) return;

    pn.publish({ channel: channelId, message: msg }).catch(() => { });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className="chat-widget">
      <div className="chat-box open">
        <div className="chat-header">
          <div className="chat-title">Chat with {fromChatlist ? sp.sp_name  : sp.service_provider.full_name}</div>
          <button onClick={onClose} className="close-btn">×</button>
        </div>

        <div className="chat-body">
          <div className="messages">
            {messages.length === 0 && <div className="empty">No messages yet. Say hi 👋</div>}

            {messages.map((m) => {
              const isMine = m.senderName === "Customer";
              console.log("image",m.image)
              return (
                <div key={m.id} className={`message ${isMine ? "mine" : "theirs"}`}>
                  {m.text &&<div className="text">{m.text}</div>}
                  {m.image && <img src={m.image} alt="sent" style={{ maxWidth: "200px", borderRadius: "8px", display: "block" }} />}
                  <span className="time">{new Date(m.ts || Date.now()).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>
                </div>
              );
            })}

            <div ref={messagesEndRef} />
          </div>

          <div className="chat-input">
            <textarea
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              rows={2}
            />
            <button onClick={sendMessage} className="send-btn">Send</button>
          </div>
        </div>
      </div>
    </div>
  );
}
